export function bread() {
  $('.c-bread_child').find('br').remove();
}
  